import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DarkBg from '@/components/dark-bg.vue';
import XdfInput from '@/views/home/compontents/xdf-input-active.vue';
import LogoutDialog from '@/views/user-center/dialog/logout.vue';
import activeError from '@/views/home/compontents/active-error.vue';
import { activate as _activate } from '@/api/home';
import { guideQuery } from '@/api/modules/guide.js';
import OutlineCache from '@/utils/OutlineCache.js';
import { getVideoUrl } from '@/utils/guide-video.js';
import { kickLogin } from '@/utils/login';
var cache;
export default {
  name: 'Active',
  components: {
    DarkBg: DarkBg,
    XdfInput: XdfInput,
    LogoutDialog: LogoutDialog,
    activeError: activeError
  },
  data: function data() {
    return {
      code: '',
      step: 1,
      showLogoutDialog: false,
      videoUrl: '',
      activeErrorDig: false,
      isFullScreen: false,
      message: ''
    };
  },
  computed: {},
  created: function created() {
    cache = OutlineCache.getInstance();
    window.addEventListener('message', this.getMessage);
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _data$;

      var params, _yield$guideQuery, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                codes: ['V0001']
              };
              _context.next = 3;
              return guideQuery(params);

            case 3:
              _yield$guideQuery = _context.sent;
              data = _yield$guideQuery.data;
              _this.videoUrl = getVideoUrl(JSON.parse((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.content)); // 根据高度设置视频的宽度
              // const video = document.getElementsByClassName('active___step1-iframe-outer')[0]
              // video.style.width = `${video.clientHeight / 0.563}px`

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.getMessage);
  },
  methods: {
    activate: function activate(val) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_activate, status, data, message, subjectBoxIdType, edu;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                val = val.trim();

                if (!(!val || val.length < 16)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", _this2.$message.error('请输入16位完整激活码'));

              case 3:
                _this2.code = val;
                _context2.next = 6;
                return _activate({
                  code: _this2.code
                });

              case 6:
                _yield$_activate = _context2.sent;
                status = _yield$_activate.status;
                data = _yield$_activate.data;
                message = _yield$_activate.message;

                if (!(status === 2)) {
                  _context2.next = 14;
                  break;
                }

                _this2.message = message;
                _this2.activeErrorDig = true;
                return _context2.abrupt("return");

              case 14:
                // 取消激活遮罩层 - 产品需求
                _this2.$store.dispatch('setUnbindSubject', false);

                subjectBoxIdType = {
                  subject: data.subjectId,
                  boxId: data.boxId,
                  preciousType: 1
                };

                _this2.$store.dispatch('setPreciousMessage', subjectBoxIdType);

                _this2.$store.dispatch('setSubject', data.subjectId);

                edu = JSON.parse(localStorage.getItem('userInfo')).edu;
                cache.switchSubject(edu, data.subjectId);
                cache.switchBox(edu, data.subjectId, data.boxId); // 设置成正常模式

                _this2.$store.dispatch('setUserMode', 'normal');

                _this2.$router.push('/study');

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    logOut: function logOut() {
      this.showLogoutDialog = true;
    },
    goBack: function goBack() {
      var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      this.step = step;
    },
    getMessage: function getMessage(_ref) {
      var data = _ref.data;
      var eventName = data === null || data === void 0 ? void 0 : data.eventName;

      if (eventName === 'landingKick') {
        kickLogin(data);
      }

      if ((data === null || data === void 0 ? void 0 : data.eventName) === 'setFullScreen') {
        this.isFullScreen = data === null || data === void 0 ? void 0 : data.fullScreen;
      }
    },
    // 去选择产品体验页
    toSelect: function toSelect() {
      // 设置成体验模式
      this.$store.dispatch('setUserMode', 'experience');
      this.$router.push('/select');
    }
  }
};